export default "__VITE_ASSET__f244a57c__"